import React from 'react';
export function UrgencyBar() {
  return <div className="bg-[#0F172A] text-[#94A3B8] text-center py-3 px-5 font-montserrat text-xs font-semibold tracking-wider uppercase border-b-2 border-[#22C55E]" data-id="element-156">
      ⏳ OFERTA DE LANZAMIENTO —{' '}
      <span className="text-[#F97316] font-extrabold" data-id="element-157">50% OFF</span> · Solo
      quedan <span className="text-[#F97316] font-extrabold" data-id="element-158">23 lugares</span>{' '}
      con todos los bonos gratis
    </div>;
}